import React from "react";

export default [
  <option key={"null"} value="" disabled="disabled"></option>,
  <option key={"ab"} value="ab">
    Alberta
  </option>,
  <option key={"bc"} value="bc">
    British Columbia
  </option>,
  <option key={"mb"} value="mb">
    Manitoba
  </option>,
  <option key={"nb"} value="nb">
    New Brunswick
  </option>,
  <option key={"nl"} value="nl">
    Newfoundland and Labrador
  </option>,
  <option key={"ns"} value="ns">
    Nova Scotia
  </option>,
  <option key={"nt"} value="nt">
    Northwest Territories
  </option>,
  <option key={"nu"} value="nu">
    Nunavut
  </option>,
  <option key={"on"} value="on">
    Ontario
  </option>,
  <option key={"pe"} value="pe">
    Prince Edward Island
  </option>,
  <option key={"qc"} value="qc">
    Quebec
  </option>,
  <option key={"sk"} value="sk">
    Saskatchewan
  </option>,
  <option key={"yt"} value="yt">
    Yukon
  </option>,
];
